<template>
    <PageHeader wide>
        <h1>
            <NuxtLink :to="manufacturerLink">{{ manufacturer?.Name }}</NuxtLink>
            <span class="ml-2">{{ seriesHeading }}</span>
        </h1>
    </PageHeader>
</template>
<script setup lang="ts">
const { t } = useI18n();
const route = useRoute();
const localePath = useLangPath();
const { manufacturer } = injectManufacturer();
const { basePartNumber } = route.params;

const seriesHeading = computed(() => t("ProductSeries.SeriesHeading", [basePartNumber]));

const manufacturerLink = computed(() => localePath("/manufacturers/" + manufacturer.value?.VirtualPath));
</script>
